import { render, staticRenderFns } from "./HelpCenterArticleView.vue?vue&type=template&id=27160942&scoped=true"
import script from "./HelpCenterArticleView.vue?vue&type=script&lang=ts"
export * from "./HelpCenterArticleView.vue?vue&type=script&lang=ts"
import style0 from "./HelpCenterArticleView.vue?vue&type=style&index=0&id=27160942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27160942",
  null
  
)

export default component.exports